import { ErrorHandler, Injectable } from '@angular/core';
import { AppVersionService } from './app-version.service';

@Injectable()
export class AppErrorHandler extends ErrorHandler {
  constructor(private appVersion: AppVersionService) {
    super();
  }

  handleError(error: unknown): void {
    if (this.appVersion.isStaleBuildError(error)) {
      this.appVersion.showReloadPrompt('chunk-error');
      return;
    }

    super.handleError(error);
  }
}
